import { render, staticRenderFns } from "./businessGoodDetail.vue?vue&type=template&id=ef5aabbc&scoped=true"
import script from "./businessGoodDetail.vue?vue&type=script&lang=js"
export * from "./businessGoodDetail.vue?vue&type=script&lang=js"
import style0 from "./businessGoodDetail.vue?vue&type=style&index=0&id=ef5aabbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5aabbc",
  null
  
)

export default component.exports